import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Form, { FormInput } from '../common/Form';
import { useState } from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faSquareArrowUpRight as goto, faClipboard as copy } from '@fortawesome/free-solid-svg-icons';

const PresetLink = ({ event, cats, cntrs, dates }) => {
	const { t, i18n } = useTranslation();
	const [ url, setUrl ] = useState('');
	const [ base, setBase ] = useState('');
	const [ type, setType ] = useState('exhibitors');
	const [ lang, setLang ] = useState(i18n.language)

	useEffect(() => {
		let url = '';
		let base = '';
		if(event) {
			base = type === 'exhibitors' ? event.catalog_url[lang] : event.schedule_url[lang];
			url  = `${base}?`;
			url += `type=${type}`;
			url += `&event=${event._id}`;
			url += `&lang=${lang}`;
			url += cats.length  ? `&cats=${cats}` : '';
			url += cntrs.length ? `&cntrs=${cntrs}` : '';
			url += dates.length ? `&dates=${dates}` : '';
		}
		setUrl(url);
		setBase(base);
	}, [ type, lang, event, cats, cntrs, dates ]);

	const onGoto = () => {
		window.open(url, '_blank');
	};

	const onCopy = () => {
		navigator.clipboard.writeText(url).then(() => alert(t('preset.copied')));
	};

	if(!event) return null;

	return (
		<div className='PresetLink'>
			{base &&
			<div>
				<span style={{color:'var(--main-color)', cursor:'pointer'}} onClick={() => onGoto()}>
					<Icon icon={goto}/>&nbsp;<u>{t('preset.goto')}</u>
				</span>
				&nbsp;&nbsp;&nbsp;
				<span style={{color:'var(--main-color)', cursor:'pointer'}} onClick={() => onCopy()}>
					<Icon icon={copy}/>&nbsp;<u>{t('preset.copy')}</u>
				</span>
			</div>}

			<Form error={base ? undefined : t('preset.nourl')}>
				<FormInput
					id='url'
					type='textarea'
					value={url}
					onChange={() => {}}
				/>
				<div style={{ display: 'flex', justifyContent: 'space-between' }}>
					<FormInput
						id='type'
						type='radio'
						value={type}
						onChange={setType}
						label={t('preset.type')}
						list={[{
							value: 'exhibitors',
							text:  t('preset.exhibitors'),
						},{
							value: 'activities',
							text:  t('preset.activities'),
						}]}
					/>
					<FormInput
						id='lang'
						type='radio'
						value={lang}
						onChange={setLang}
						label={t('preset.lang')}
						list={[{
							value: 'ru',
							text:  t('preset.russian'),
						},{
							value: 'en',
							text:  t('preset.english'),
						}]}
					/>
                </div>
			</Form>
		</div>
	);
};

PresetLink.propTypes = {
    event: PropTypes.object.isRequired,
	cats:  PropTypes.string.isRequired,
	cntrs: PropTypes.string.isRequired,
	dates: PropTypes.string.isRequired,
};

export default PresetLink;
